import React, { useEffect, useState } from 'react'
import Menu from './Menu.js';
import Homepage from './Homepage.js';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate} from 'react-router-dom';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import { makeStyles, createStyles, withStyles, Theme } from '@material-ui/core/styles';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useAuth0 } from "@auth0/auth0-react";
import Chip from '@mui/material/Chip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneIcon from '@mui/icons-material/Done';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonGroup from '@mui/material/ButtonGroup';
import AddIcon from '@mui/icons-material/Add';

const App = (props) => {

    const queryParams = new URLSearchParams(window.location.search);
    const my_variant_id = queryParams.get('id');

    const [selectedMarketplaceGroup, setSelectedMarketplaceGroup] = useState('');

    const [selectedValues, setSelectedValues] = useState([]);
    const [newPrice, setNewPrice] = useState();

    const handleEanOnClick = (id) => navigate('/Product?language=nl-NL&id=' + id);

    const loadData = () => {

           console.log('Start')

           const url = '/api/get_marketplace_offer' + '?variant=' + my_variant_id;

           const fetchData = async (my_variant_id) => {
               try {
                   const response = await fetch(url, requestOptions);
                   const json = await response.json();

                   console.log(json)

                   setData(json)

              } catch (error) {
                  console.log("error", error);
              }
          };

          const urlGroup = '/api/get_marketplace_offer_grouped' + '?variant=' + my_variant_id;

          const requestOptions = {
            method: 'GET',
            headers: { 'Authentication': 'Basic bGxveWQ6aG9ua2JhbA==' }
          };

          const fetchDataGroup = async () => {
              try {
                  const responseGroup = await fetch(urlGroup, requestOptions);
                  const jsonGroup = await responseGroup.json();

                  console.log(jsonGroup)
                  setDataGroup(jsonGroup)

             } catch (error) {
                 console.log("error", error);
             }
         };

           fetchDataGroup();
           fetchData();
       };


       useEffect(() => {
         loadData();
       }, [])


         const ColorButton = styled(Button)(({ theme }) => ({
           color: '#1976d2',
           backgroundColor: 'transparent',
           fontSize: '14px',
           textTransform: 'none',
           textAlign: 'left',
           '&:hover': {
             textDecoration: 'underline',
             backgroundColor: 'transparent',
           },
         }));

  const [dataGroup, setDataGroup] = useState([]);
  const [data, setData] = useState([]);

  const navigate = useNavigate();
  const handleOnClick = (url) => window.open(url, "_blank", "noreferrer");

  const { logout, isAuthenticated } = useAuth0();
  const { loginWithRedirect } = useAuth0();

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (isExpanded) => {
    setExpanded(panel !== expanded ? panel : false);
    closePriceField();
  };

  const openPriceField = (marketplace, ean, price, nr_of_eans, variant, exchange_rate) => {
    setNewPrice(price)
    setSelectedValues([marketplace, ean, price, nr_of_eans, variant, exchange_rate])
  };

  const closePriceField = () => {
    setSelectedValues([]);
  };

  const [confirmDialog, setConfirmDialog] = React.useState(false);

  const onChange = (e) => {
      const { target: { name, value } } = e;
      setNewPrice(value.replace(',', ''))
  }

  const submitNewPrice = () => {
    if(!isNaN(newPrice)){
      if(selectedValues[3] > 1){ //ask for confirmation with more than 1 offer
        openConfirmDialog();
      }else{
        adjustPrice()
      }
    }
  };

  const adjustPrice = () => {

    closeConfirmDialog();
    handleOpenLoadingScreen();

    console.log('Adjust price to ' + newPrice + ' for:')
    console.log(selectedValues);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authentication", "Basic bGxveWQ6aG9ua2JhbA==");

    const price_lc = newPrice * selectedValues[5]  //multiply by the exchange rate

    var raw = '{"marketplace":"' + selectedValues[0] + '",';
    raw = raw + '"ean":"' + selectedValues[1] + '",';
    raw = raw + '"price":"' + price_lc.toFixed(2) + '",'; //round to 2 decimals
    raw = raw + '"nr_of_eans":"' + selectedValues[3] + '",';
    raw = raw + '"variant":"' + selectedValues[4] + '"}';

    console.log(raw)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("/api/update_price_marketplace", requestOptions)
      .then(response => response.text())
      .then(result => {
        loadData();
        closePriceField();
        handleCloseLoadingScreen();
      }
      )
      .catch(error => console.log('error', error));
  }

  const openConfirmDialog = () => {
    setConfirmDialog(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialog(false);
  };

  const [openLoadingScreen, setOpenLoadingScreen] = React.useState(false);
  const handleCloseLoadingScreen = () => {
    setOpenLoadingScreen(false);
  };
  const handleOpenLoadingScreen = () => {
    setOpenLoadingScreen(true);
  };


  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      foto_field: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '&:hover': {
          cursor: 'pointer',
        },
      },
      full_root: {
        backgroundColor: '#F4F4F4'
      },
      paper_custom: {
        padding: '10px 15px 30px 15px',
      },
      head_top_text: {
        margin: 'auto',
        fontSize: '13px'
      },
      bulk_item: {
        width: '120px',
        margin: '0px 0px 10px 10px',
        textAlign: 'center',
        height: '58px',
        paddingTop: '5px',
        color: '#555e68',
        '&:hover': {
          cursor: 'pointer',
          color: '#9452c0',
          border: '1px solid #9452c0'
        },
      },
      bulk_icon: {
        color: '#000'
      },
      bulk_icon_inactive: {
        color: '#97999c'
      },
      basic_link: {
        '&:hover': {
          cursor: 'pointer',
          textDecoration: 'underline'
        }
      }
    }),
  );

 const classes = useStyles();


  if (isAuthenticated) {

  return (

    <div className={classes.full_root}>

    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoadingScreen}
        onClick={handleCloseLoadingScreen}
      >
        <CircularProgress color="inherit" />
    </Backdrop>

    <Grid container>

      <Grid item xs="auto">

        <Menu navigate={navigate} page={'channel_sync'}/>

      </Grid>

      <Grid xs>

    <div>
    <div style={{margin: '55px 0px 55px 0px', padding: '0px 20px 40px 20px'}}>


    <div>

    <Paper
    className={classes.paper_custom}
    sx={{borderTopLeftRadius: 4, borderTopRightRadius: 4, borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}
    style={{width: '870px', margin: '80px auto 0px auto'}}
    >

    <Button
      variant="outlined"
      color="primary"
      size="small"
      style={{ textTransform: 'none', marginRight: '20px' }}
      startIcon={<ArrowBackIosIcon />}
      onClick={() => navigate(-1)}
    >
      Back
    </Button>

    <div style={{width: '100%', textAlign: 'center'}}>

    {data.slice(0, 1).map((x) => (
      <div>
      <div style={{fontSize: '20px', fontWeight: 'bold'}}> { x.variant_title } </div>

        {dataGroup.slice(0, 1).map((y) => (
        <div style={{fontSize: '14px'}}>{'(' + y.total_ean_count + ' variant' + (y.total_ean_count > 1 ? 's)' : ')')}</div>
        ))}

      <img src={x.url} style={{height: '130px', marginTop: '20px'}} />
      </div>
     ))}

     </div>


    </Paper>

    <Paper
    className={classes.paper_custom}
    sx={{borderTopLeftRadius: 0, borderTopRightRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}
    style={{width: '870px', margin: '0px auto 0px auto', textAlign: 'center'}}
    >
             <ButtonGroup color="primary" aria-label="Medium-sized button group">
               <Button key="All" onClick={() => setSelectedMarketplaceGroup('')} variant={selectedMarketplaceGroup === '' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 35px 8px 35px'}}>All</Button>
               <Button key="Amazon" onClick={() => setSelectedMarketplaceGroup('Amazon')} variant={selectedMarketplaceGroup === 'Amazon' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 20px 8px 20px'}}>Amazon</Button>
               <Button key="Bol.com" onClick={() => setSelectedMarketplaceGroup('Bol.com')} variant={selectedMarketplaceGroup === 'Bol.com' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 20px 8px 20px'}}>Bol.com</Button>
               <Button key="Decathlon" onClick={() => setSelectedMarketplaceGroup('Decathlon')} variant={selectedMarketplaceGroup === 'Decathlon' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 20px 8px 20px'}}>Decathlon</Button>
               <Button key="Shopify" onClick={() => setSelectedMarketplaceGroup('Shopify')} variant={selectedMarketplaceGroup === 'Shopify' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 20px 8px 20px'}}>Shopify</Button>
               <Button key="Showroom" onClick={() => setSelectedMarketplaceGroup('Showroom')} variant={selectedMarketplaceGroup === 'Showroom' ? 'contained' : 'outlined'} style={{ textTransform: 'none', padding: '8px 20px 8px 20px'}}>Showroom</Button>
             </ButtonGroup>
        </Paper>



    <Accordion
    disabled
    style={{width: '900px', margin: '0px auto', backgroundColor: 'white', color: 'black', fontSize: '14px'} }
    >
      <AccordionSummary
        style={{cursor: 'default'}}
      >

      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "flex-start",
          alignItems: "center",
          width: "850px",
          margin: '0px auto'
        }}
      >

       <Grid style={{width: '200px'}}>Marketplace</Grid>

       <Grid style={{width: '180px'}}>Nr. of offers</Grid>

       <Grid style={{width: '200px'}}>Price (€)</Grid>

       <Grid style={{width: '100px'}}>Margin</Grid>

       <Grid style={{width: '170px', textAlign: 'right'}}>Edit price per variant</Grid>

     </Grid>

      </AccordionSummary>
    </Accordion>


    {dataGroup.filter(mp => mp.marketplace.startsWith(selectedMarketplaceGroup)).map((value) => (


       <Accordion
       expanded={expanded === value.marketplace}
       style={expanded === value.marketplace ? {margin: '40px auto 40px auto', width: '900px', border: '2px solid #982aad'} : {width: '900px', margin: '0px auto'} }
       >
         <AccordionSummary
           aria-controls="panel1bh-content"
           id="panel1bh-header"
           style={expanded && expanded !== value.marketplace ? {cursor: 'default', backgroundColor: '#eee'} : {cursor: 'default', backgroundColor: 'white'}}
         >

         <Grid
           container
           direction="row"
           sx={{
             justifyContent: "flex-start",
             alignItems: "center",
             width: "850px",
             margin: '0px auto',
             fontSize: '14px'
           }}
         >

          <Grid style={{width: '200px'}}><b>{ value.marketplace }</b></Grid>

          <Grid style={{width: '180px'}}>{ value.nr_of_eans } offer{value.nr_of_eans !== 1 && 's'}</Grid>

          <Grid style={{width: '200px'}}>
              {expanded !== value.marketplace &&
                <div style={{ color: '#1976d2' }}>
                {selectedValues[0] !== value.marketplace || selectedValues[1] !== 'bulk' ?
                <Tooltip title="Edit" placement="right" enterDelay={0} leaveDelay={0}>
                  <ColorButton style={{ color: '#1976d2', minWidth: '0px'}} onClick={() => {openPriceField(value.marketplace, 'bulk', value.price_text, value.nr_of_eans, my_variant_id, value.exchange_rate)}}> {value.price_text ? '€ ' + value.price_text : '€ --'} </ColorButton>
                </Tooltip>
                  :
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <TextField
                  name="price"
                  autoFocus
                  label={isNaN(newPrice) && 'Invalid price'}
                  size="small"
                  id="outlined-required"
                  value={newPrice}
                  inputProps={{ size: 8 }}
                  InputProps={{ style: { fontSize: 14 } }}
                  error={isNaN(newPrice)}
                  onChange={onChange}
                />
                  <IconButton aria-label="ok" size="small" onClick={submitNewPrice} style={isNaN(newPrice) ? {color: 'gray'} : {color: 'green'}} disabled={isNaN(newPrice)}>
                    <DoneIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton aria-label="close" size="small" onClick={closePriceField}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                </Stack>
                }
              </div>
              }
          </Grid>

          <Grid style={{width: '100px', textAlign: 'left'}}>
            {expanded !== value.marketplace && value.min_margin === value.max_margin ? value.min_margin : value.min_margin + ' - ' + value.max_margin}
          </Grid>

          <Grid style={{width: '170px', textAlign: 'right'}}>
          <Button sx={{ textTransform: 'none' }} startIcon={expanded !== value.marketplace ? <ExpandMoreIcon /> : <CloseIcon />} variant="outlined" size="small" onClick={handleChange(value.marketplace)}>
              {expanded === value.marketplace ?  'Close' : 'Expand'}
          </Button>
          </Grid>

        </Grid>

         </AccordionSummary>

         <AccordionDetails style={{padding: '0px'}}>

         <TableContainer component={Paper}>
          <Table sx={{ minWidth: 900 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow style={{borderTop: '1px solid #dfdfdf'}}>
                <TableCell><b>Image</b></TableCell>
                <TableCell align="left"><b>EAN</b></TableCell>
                <TableCell align="left"><b>Price</b></TableCell>
                <TableCell align="left"><b>Discount</b></TableCell>
                <TableCell align="left"><b>Margin</b></TableCell>
                <TableCell align="left"><b>Size</b></TableCell>
                <TableCell align="left"><b>Color</b></TableCell>
                <TableCell align="left"><b>Stock</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

             {data.filter(y => y.marketplace == value.marketplace).map((value_y) => (

               <TableRow
                 key={value_y.ean}
                 sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
               >
                 <TableCell component="th" scope="row">
                    <img src={value_y.url} style={{height: '40px', cursor: 'pointer'}} onClick={() => {handleEanOnClick(value_y.ean)}}/>
                 </TableCell>
                 <TableCell align="left">{ value_y.ean }</TableCell>
                 <TableCell align="left" sx={{width: '140px'}}>

                     <div>
                       {selectedValues[0] !== value.marketplace || selectedValues[1] !== value_y.ean ?
                         <Tooltip title="Edit" placement="right" enterDelay={0} leaveDelay={0}>
                           <ColorButton style={{ color: '#1976d2', minWidth: '0px'}} onClick={() => {openPriceField(value.marketplace, value_y.ean, value_y.price, 1, my_variant_id, value_y.exchange_rate)}}> {value_y.price ? '€ ' + value_y.price : '€ --' } </ColorButton>
                         </Tooltip>
                           :
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                         <TextField
                           name="price"
                           autoFocus
                           label={isNaN(newPrice) && 'Invalid price'}
                           size="small"
                           id="outlined-required"
                           value={newPrice}
                           inputProps={{ size: 5 }}
                           InputProps={{ style: { fontSize: 14 } }}
                           error={isNaN(newPrice)}
                           onChange={onChange}
                         />
                           <IconButton aria-label="ok" size="small" onClick={submitNewPrice} style={isNaN(newPrice) ? {color: 'gray'} : {color: 'green'}} disabled={isNaN(newPrice)}>
                             <DoneIcon fontSize="inherit" />
                           </IconButton>
                           <IconButton aria-label="close" size="small" onClick={closePriceField}>
                             <CloseIcon fontSize="inherit" />
                           </IconButton>
                         </Stack>
                       }
                     </div>

                  </TableCell>

                <Tooltip disableHoverListener={value_y.discount_period === 'n/a'} title={value_y.discount_period} placement="top" enterDelay={0} leaveDelay={0}>
                  <TableCell align="left" sx={{width: '140px'}}>

                  <div>
                    {1===1 ?
                      <Tooltip title={value_y.price_discount & value_y.price_discount !== '0.00' ? 'Edit' : 'Add'} placement="right" enterDelay={0} leaveDelay={0}>
                        <ColorButton style={{ color: '#1976d2', minWidth: '0px'}}>
                        { value_y.price_discount & value_y.price_discount !== '0.00' ?  '€ ' + value_y.price_discount
                      :
                      <AddIcon style={{fontSize: '18px', color: 'gray'}} />}

                       </ColorButton>
                      </Tooltip>
                        :
                     <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                      <TextField
                        name="price"
                        autoFocus
                        label={isNaN(newPrice) && 'Invalid price'}
                        size="small"
                        id="outlined-required"
                        value={newPrice}
                        inputProps={{ size: 5 }}
                        InputProps={{ style: { fontSize: 14 } }}
                        error={isNaN(newPrice)}
                        onChange={onChange}
                      />
                        <IconButton aria-label="ok" size="small" onClick={submitNewPrice} style={isNaN(newPrice) ? {color: 'gray'} : {color: 'green'}} disabled={isNaN(newPrice)}>
                          <DoneIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton aria-label="close" size="small" onClick={closePriceField}>
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      </Stack>
                    }
                  </div>


                    </TableCell>
                 </Tooltip>

                 <TableCell align="left">{ value_y.margin }</TableCell>
                 <TableCell align="left">{ value_y.size }</TableCell>
                 <TableCell align="left">{ value_y.color }</TableCell>
                 <TableCell align="left" style={value_y.stock === 0 ? {color: 'red'} : {color: 'black'}}>{ value_y.stock }</TableCell>
               </TableRow>

              ))}
              </TableBody>
            </Table>
          </TableContainer>

         </AccordionDetails>
       </Accordion>

    ))}



    <Dialog
        open={confirmDialog}
        onClose={closeConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {'Do you want to change the price to ' + newPrice + ' for ' + selectedValues[3]  + ' offers on ' + selectedValues[0] + '?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmDialog}>Cancel</Button>
          <Button onClick={adjustPrice} autoFocus>
            Yes, change prices
          </Button>
        </DialogActions>
      </Dialog>





   </div>


      </div>

      </div>

      </Grid>

    </Grid>

      </div>
  )
}
else {
  return (
      <Homepage />
)
}
}

export default () => <App />
